import ninegrid from "../index.js";
import { ngElement } from './_ngElements.js';

class ngRowExpand extends ngElement
{
	#owner;
	#cell;
	#originExpr;
	
	constructor () {
		super();

		this.applyBaseStyle();
	}
	
	connectedCallback() {

		//console.log("%%%%%%%%%%%", ninegrid.version);

		this.shadowRoot.innerHTML = ``;

		super.connectedCallback();
		
		this.#owner		= this.getRootNode().host;
		this.#cell		= this.closest("th,td");
		
		if (!this.#owner || !this.#cell) return;
		
		//this.#originExpr= $(`[data-col="${this.#cell.dataset.col}"]`, this.#owner.template).attr("data-expr");
		this.#originExpr= ninegrid.j.querySelectorAll(`[data-col="${this.#cell.dataset.col}"]`, this.#owner.tmpl).attr("data-expr");
		
		if (this.#cell.querySelector("ng-col-expand")) {
			ninegrid.j.querySelectorAll(this).addClass("padding");
		}
		
		$(this).on("click", e => {
			e.preventDefault();
			e.stopPropagation();
			
			if (ninegrid.j.querySelectorAll(this).hasClass("expand")) {
				this.#collapse();
			}
			else {
				this.#expand();
			}
		});
		
		$(this).on("click", e => { e.stopPropagation(); });
	};
	
	#expand = () => {
		const bind = ninegrid.j.querySelectorAll(`[data-col="${this.#cell.dataset.col}"]`, this.#owner.tmpl).attr("data-bind");
		const expr = `data.${bind}.replaceAll("\\n", "<br>")`;

		ninegrid.j.querySelectorAll(this).addClass("expand");
		
		ninegrid.j.querySelectorAll(`[data-col="${this.#cell.dataset.col}"]`, this.#owner.tmpl).attr("data-expr", expr);
		ninegrid.j.querySelectorAll(`[data-col="${this.#cell.dataset.col}"]`, this.#owner.body).attr("data-expr", expr);
		
		this.#setRowHeightFit();
	};
	
	#collapse = () => {
		
		ninegrid.j.querySelectorAll(this).removeClass("expand");
		
		if (this.#originExpr) {
			ninegrid.j.querySelectorAll(`[data-col="${this.#cell.dataset.col}"]`, this.#owner.tmpl).attr("data-expr", this.#originExpr);
			ninegrid.j.querySelectorAll(`[data-col="${this.#cell.dataset.col}"]`, this.#owner.body).attr("data-expr", this.#originExpr);
		}
		else {
			ninegrid.j.querySelectorAll(`[data-col="${this.#cell.dataset.col}"]`, this.#owner.tmpl).removeAttr("data-expr");
			ninegrid.j.querySelectorAll(`[data-col="${this.#cell.dataset.col}"]`, this.#owner.body).removeAttr("data-expr");
		}
		
		this.#setRowHeightFit();
	};
	
	#setRowHeightFit = () => {
		var arr = [];
		this.#owner.body.querySelectorAll("thead ng-row-expand.expand").forEach(v => {
			const col = v.closest("th,td").dataset.col;
			arr.push(`th[data-col="${col}"],td[data-col="${col}"]`);
		});
		
		var tds = [];
		for (var i = 0; i < this.#owner.template.length; i++) {
			tds.push($(arr.join(","), this.#owner.template.eq(i)));
		}
		
		this.#owner.setRowHeightFitAll(tds);
	}
}


if (!customElements.get('ng-combo')) {
	customElements.define("ng-combo", ngRowExpand);
}

